import { render, staticRenderFns } from "./security-code-verification.vue?vue&type=template&id=582bf3ed&"
import script from "./security-code-verification.vue?vue&type=script&lang=js&"
export * from "./security-code-verification.vue?vue&type=script&lang=js&"
import style0 from "./security-code-verification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports